import { IModel, Model, ModelRecord } from './Model';
import { NoteTypeModel } from './NoteTypeModel';

export interface IClientNoteModel extends IModel {
  clientNoteId: number;
  clientId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  dateCreated: string;
}

export class ClientNoteModel
  extends Model
  implements ModelRecord<IClientNoteModel>
{
  clientNoteId: number;
  clientId: number;
  noteTypeId: number;
  noteType: NoteTypeModel;
  notes: string;
  createdUserTitle: string;
  createdUserFirstName: string;
  createdUserLastName: string;
  dateCreated: string;

  constructor(params?: Partial<IClientNoteModel>) {
    super(params);
    this.clientNoteId = _.defaultTo(params?.clientNoteId, 0);
    this.clientId = _.defaultTo(params?.clientId, 0);
    this.noteTypeId = _.defaultTo(params?.noteTypeId, 0);
    this.noteType = params?.noteType
      ? new NoteTypeModel(params?.noteType)
      : new NoteTypeModel();
    this.notes = _.defaultTo(params?.notes, '');
    this.createdUserTitle = _.defaultTo(params?.createdUserTitle, '');
    this.createdUserFirstName = _.defaultTo(params?.createdUserFirstName, '');
    this.createdUserLastName = _.defaultTo(params?.createdUserLastName, '');
    this.dateCreated = _.defaultTo(params?.dateCreated, '');
  }
}
